import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inputFloatLabel: {
    description: 'saveFilterViewModal.inputFloatLabel',
    defaultMessage: 'View Name',
    id: 'YU9epz',
  },
  selectFilterView: {
    description: 'saveFilterViewModal.selectFilterView',
    defaultMessage: 'Select View',
    id: 'S9BkJv',
  },
  dropdownLabel: {
    description: 'saveFilterViewModal.dropdownLabel',
    defaultMessage: 'Overwrite View',
    id: '9BQRxk',
  },
});
